import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8c29658c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "print:hidden flex flex-row items-center justify-between px-8 py-4 bg-blue-700 max-[310px]:px-3 max-[310px]:justify-end"
}
const _hoisted_2 = { class: "flex flex-row items-center" }
const _hoisted_3 = {
  key: 0,
  class: "absolute flex flex-col items-start justify-center px-2 py-2 mt-2 text-black bg-white rounded-lg shadow-md w-32 z-10"
}
const _hoisted_4 = {
  key: 1,
  class: "flex flex-row items-center content-between justify-center px-4 py-4 bg-blue-700"
}
const _hoisted_5 = { class: "flex flex-row items-center justify-between text-2xl tracking-wider text-white" }
const _hoisted_6 = ["src"]

import { ref, computed } from 'vue'
import { useRouter } from 'vue-router'
import { Auth } from '@aws-amplify/auth'
import BaseIcon from './BaseIcon.vue'
import BrandLogo from './BrandLogo.vue'
import UserAvatar from '@/components/UserAvatar.vue'
import { useUserStore } from '@/stores/user'
import AdminBadge from '@/components/icons/AdminBadge.vue'

// Reactive state

export default /*#__PURE__*/_defineComponent({
  __name: 'AppHeader',
  setup(__props) {

const dropdownIsVisible = ref(false)
const initialDropdownClick = ref(true)
const userStore = useUserStore()
const router = useRouter()

// Methods
const toggleDropdown = () => {
  if (dropdownIsVisible.value) {
    initialDropdownClick.value = true
  }
  dropdownIsVisible.value = !dropdownIsVisible.value
}

const onClickOutsideDropdown = () => {
  if (dropdownIsVisible.value) {
    if (initialDropdownClick.value) {
      initialDropdownClick.value = false
    } else {
      dropdownIsVisible.value = false
      initialDropdownClick.value = true
    }
  }
}

const goToAdmin = () => {
  toggleDropdown()
  router.push('/admin/campaigns')
}
const goToContributr = () => {
  toggleDropdown()
  router.push('/draft-crew')
}

const signOut = () => {
  Auth.signOut()
}

// Computed property for org-name based on the hostname
const orgName = computed(() => {
  const hostname = window.location.hostname
  if (hostname.includes('fivestardev.com')) return 'fivestar'
  if (hostname.includes('simplesoft.net')) return 'simplesoft'
  return 'ingage'
})

return (_ctx: any,_cache: any) => {
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_unref(userStore).userId)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(BrandLogo, { "org-name": _unref(orgName) }, null, 8, ["org-name"]),
        _createElementVNode("div", _hoisted_2, [
          (_unref(userStore).isAdmin)
            ? (_openBlock(), _createBlock(AdminBadge, { key: 0 }))
            : _createCommentVNode("", true),
          _createElementVNode("div", null, [
            _createElementVNode("button", {
              class: "flex items-center space-x-2 text-white rounded-full pr-2 hover:bg-white/[.16] max-[310px]:pr-1 max-[310px]:space-x-1",
              onClick: toggleDropdown
            }, [
              _createVNode(UserAvatar, {
                class: "img-container",
                "image-url": _unref(userStore).avatarUrl
              }, null, 8, ["image-url"]),
              _createElementVNode("div", null, _toDisplayString(_unref(userStore).displayName), 1),
              _createVNode(BaseIcon, { name: "chevron" })
            ]),
            (dropdownIsVisible.value)
              ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [
                  (_unref(userStore).isAdmin)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        "data-testid": "contributr-button",
                        class: "w-full px-2 py-2 rounded-lg hover:bg-gray-100 text-start",
                        onClick: goToContributr
                      }, " Contributr "))
                    : _createCommentVNode("", true),
                  (_unref(userStore).isAdmin)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        "data-testid": "admin-button",
                        class: "w-full px-2 py-2 rounded-lg hover:bg-gray-100 text-start",
                        onClick: goToAdmin
                      }, " Admin "))
                    : _createCommentVNode("", true),
                  _createElementVNode("button", {
                    "data-testid": "sign-out-button",
                    class: "w-full px-2 py-2 rounded-lg hover:bg-gray-100 text-start",
                    onClick: signOut
                  }, " Sign out ")
                ])), [
                  [_directive_click_outside, onClickOutsideDropdown]
                ])
              : _createCommentVNode("", true)
          ])
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("img", {
            src: require(`@/assets/images/contributr-logo.svg`),
            class: ""
          }, null, 8, _hoisted_6)
        ])
      ]))
}
}

})